import React, { useEffect } from 'react';

import AppRouteSwitch from './routes/AppRouteSwitch';
import DefaultSnackbar from 'features/snackbar/DefaultSnackbar';
import { useLocation } from 'react-router-dom';
import { watchUserData } from 'features/app_user/appUserSlice';
import { useAppDispatch } from './store';

export default function App() {

    const location = useLocation();
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(watchUserData('#1'));
    }, [dispatch, location]);

    return (
        <>
            <DefaultSnackbar />
            <AppRouteSwitch />
        </>
    );
}
